// apps/nexi-dashboard/frontend/src/constants/analyticsEventMeta.js

export const VOICEMAIL_FLOW_TAG = 'voicemail';

/** Sort key for primary tag on event cards (lower = earlier). */
export const TAGS_ORDER = {
  inbound: 0,
  voicemail: 1,
  outbound: 2,
  whatsapp: 3,
  dashboard: 4,
  error: 9,
};

export const TAG_LABELS = {
  inbound: 'Inbound',
  voicemail: 'Voicemail',
  outbound: 'Outbound',
  whatsapp: 'WhatsApp',
  dashboard: 'Dashboard',
  error: 'Error',
};

const UNKNOWN_TAG_RANK = 98;

export const ANALYTICS_EVENT_META = {
  twilio_mctb_inbound: {
    tags: ['inbound'],
    description: 'Twilio 把來電 webhook 打到 Nexi 時發生。(當 voice mail forced 時，所有 miss call 會變為語音留言，因此略過此事件)',
    order: 0
  },
  outbound_text_message_sent: {
    tags: ['outbound'],
    description: '發送 WhatsApp 文字訊息。',
    order: 0
  },
  outbound_template_message_sent: {
    tags: ['outbound'],
    description: '發送 WhatsApp 模板訊息。(模板訊息包含: 未接來電 Greeting Message, OTP, CRON 如預約提示、問卷評分, etc)',
    order: 0
  },
  outbound_image_message_sent: {
    tags: ['outbound'],
    description: '發送 WhatsApp 圖片/文件/影片訊息。',
    order: 0
  },
  twilio_voice_mail: {
    tags: ['voicemail'],
    description: '來電收到語音留言（例如：診所繁忙，請在提示音後留言）。',
    order: 0
  },
  twilio_voice_mail_anonymous: {
    tags: ['voicemail'],
    description: '匿名來電收到語音留言（例如：診所繁忙，請在提示音後留言）。',
    order: 0
  },
  twilio_voice_mail_success: {
    tags: ['voicemail'],
    description: '留言流程已執行，成功錄到留言。',
    order: 1
  },
  twilio_empty_voice_mail: {
    tags: ['voicemail'],
    description: '留言流程已執行，錄音為空。',
    order: 1
  },
  send_assistant_message: {
    tags: ['voicemail'],
    description: '向診所助理發送 WhatsApp 通知。例如：Nexi 於 {{1}} 收到來自 {{2}} 的語音留言：{{3}} 請回覆。',
    order: 1
  },
  waba_whatsapp_inbound: {
    tags: ['whatsapp'],
    description: '經 Waba 收到 whatsapp 訊息。',
    order: 0
  },
  twilio_whatsapp_inbound: {
    tags: ['whatsapp'],
    description: '經 Twilio 收到 whatsapp 訊息。',
    order: 0
  },
  notify_clinic_leave_message: {
    tags: ['whatsapp'],
    description: '留言已發送至診所。',
    order: 1
  },
  notify_clinic_mctb: {
    tags: ['whatsapp', 'mctb'],
    description: '未接來電已發客戶 WhatsApp 歡迎模板後，向診所職員發送 MCTB 通知。',
    order: 1
  },
  emergency_appointment_requested: {
    tags: ['whatsapp'],
    description: '緊急預約已發送至診所。',
    order: 2
  },
  appointment_notification_sent: {
    tags: ['whatsapp'],
    description: '預約通知已發送至診所。',
    order: 2
  },
  escalate_message_to_team: {
    tags: ['whatsapp'],
    description: '轉發訊息至團隊。(Coexistence, eg. DEMO_CAS_SUPPORT)',
    order: 4
  },
  waba_whatsapp_flow_inbound: {
    tags: ['whatsapp'],
    description: '收到 WhatsApp 表格。(於 HKSH 通常是指成功提交預約表格)',
    order: 3
  },
  portal_toolbox_executed: {
    tags: ['dashboard'],
    description: '執行 dashboard 工具箱功能。(主要為 HKSH OGC chief complaint 測試)',
    order: 0
  },
  'error::nexi_inbound::failed': {
    tags: ['error'],
    description: 'Nexi Inbound 處理失敗。',
    order: 0
  },
  'error::nexi_agent::failed': {
    tags: ['error'],
    description: 'Nexi Agent 處理失敗。',
    order: 0
  },
};

export function getAnalyticsEventMeta(eventName) {
  return ANALYTICS_EVENT_META[eventName] ?? { tags: [], description: null, order: 99 };
}

/** Sort [eventName, count] pairs by TAGS_ORDER, then meta.order, then name. */
export function sortAnalyticsEventEntries(entries) {
  return [...entries].sort(([nameA], [nameB]) => {
    const metaA = getAnalyticsEventMeta(nameA);
    const metaB = getAnalyticsEventMeta(nameB);
    const rankA = TAGS_ORDER[metaA.tags?.[0] ?? ''] ?? UNKNOWN_TAG_RANK;
    const rankB = TAGS_ORDER[metaB.tags?.[0] ?? ''] ?? UNKNOWN_TAG_RANK;
    if (rankA !== rankB) return rankA - rankB;
    const orderA = metaA.order ?? 99;
    const orderB = metaB.order ?? 99;
    if (orderA !== orderB) return orderA - orderB;
    return nameA.localeCompare(nameB);
  });
}
